import { ENDPOINTS } from "@/constants"
import { useDownloadCSV, useSalesSearchParams } from "@/hooks"

import { ExportButton } from "../commons/export-button"
export const TransactionsDownload = () => {
  const { params } = useSalesSearchParams()
  const fileName = `transacoes_${new Date().getTime()}.csv`
  const endpoint = ENDPOINTS.TRANSACTION_DOWNLOAD
  const { handleDownload, isDownloading } = useDownloadCSV({
    endpoint,
    fileName,
    params: params as DownloadCSVParamsType,
  })
  return <ExportButton onClick={handleDownload} disabled={isDownloading} />
}
